exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n@keyframes spinner {\r\n    to {transform: rotate(360deg);}\r\n  }\r\n  \r\n  .spinner:before {\r\n    content: '';\r\n    box-sizing: border-box;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 80px;\r\n    height: 80px;\r\n    margin-top: -10px;\r\n    margin-left: -40px;\r\n    border-radius: 50%;\r\n    border: 6px solid #6F6F6F;\r\n    border-top-color: #45DBFF;\r\n    animation: spinner 1s linear infinite;\r\n  }\r\n  \r\n  .busy-spinner-loading {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 2001;\r\n  }\r\n  \r\n  .busy-spinner-loading::before {\r\n    content: \" \";\r\n    background: rgba(0, 0, 0, 0.5);\r\n    z-index: 2002; /* Higher than modal z-index and busy-spinner-loading z-index */\r\n    display: inline-block;\r\n    height: 100%;\r\n    width: 100%;\r\n    position: relative;\r\n  }\r\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/services/busy-spinner/busy-spinner.component.css
// module id = ../../../../../src/app/services/busy-spinner/busy-spinner.component.css
// module chunks = 0